export function getUserAccess(module) {
  // return {
  //   view: module.view === 'TRUE',
  //   create: module.create === 'TRUE',
  //   update: module.edit === 'TRUE',
  //   print: module.print === 'TRUE',
  // }

  // Handle undefined/null modules gracefully
  if (!module) {
    return {
      view: 'FALSE',
      create: 'FALSE',
      update: 'FALSE',
      print: 'FALSE',
      post: 'FALSE',
      cancel: 'FALSE',
      override: 'FALSE',
    };
  }

  return {
    view: module.vw,
    create: module.crt,
    update: module.edt,
    print: module.prnt,
    post: module.pst,
    cancel: module.cncl,
    override: module.ovr,
  }
}

export function omit(obj, keysToOmit) {
  let newObj = [];

  Object.keys(obj).forEach(key => {
    if(!keysToOmit.includes(key)) newObj[key] = obj[key];
  });

  return newObj;
}